import React from 'react';

import logoText from 'assets/logo-text.svg';
import { useMediaQueryContext } from 'contexts/mediaQueryContext';
import Card from 'ui/Card';
import { Box, VStack } from 'ui/Layout';
import Separator from 'ui/Separator';

const MinimalPageLayoutRoot: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <VStack alignItems="center" gap={6} p={12}>
    <Box maxW="300px" w="full">
      <img src={logoText} />
    </Box>
    {children}
  </VStack>
);

const MinimalPageLayoutContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isScreenWiderThan480 } = useMediaQueryContext();
  return isScreenWiderThan480 ? (
    <Card.Root maxW="420px" w="full">
      <Card.Body boxShadow="lg">{children}</Card.Body>
    </Card.Root>
  ) : (
    // For mobile, remove the border, shadow and padding, effectively hiding the card.
    // NOTE: We could have done this with a simple Box but then the inputs would rerender
    // on resizing the window, losing their values and focus.
    <Card.Root border="none" mt={4} w="full">
      <Card.Body boxShadow="none" p={0}>
        {children}
      </Card.Body>
    </Card.Root>
  );
};

const MinimalPageLayoutFooter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isScreenWiderThan480 } = useMediaQueryContext();
  return (
    <>
      {!isScreenWiderThan480 && <Separator mx="auto" my={0} w="100px" />}
      {children}
    </>
  );
};

const MinimalPageLayout = {
  Root: MinimalPageLayoutRoot,
  Content: MinimalPageLayoutContent,
  Footer: MinimalPageLayoutFooter,
};

export default MinimalPageLayout;
